import React, { useEffect, useRef, useState } from "react";
import * as PrimeDataTable from "primereact/datatable";
import { Column } from "primereact/column";
import { DropdownItem, DropdownMenu, Modal, Spinner, UncontrolledDropdown } from "reactstrap";
import { Ripple } from "primereact/ripple";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { FilterMatchMode } from "primereact/api";
import BizinBackend from "../../helpers/bizin_helper";
import { useSelector } from "react-redux";
import IconWithTooltip from "../Common/IconWithTooltip";
import ImageWithTooltip from "../Common/ImageWithTooltip";
import MessageContentBox from "../Common/Message/MessageContentBox";
import CardFlowDynamic from "../Common/CardFlowDynamic";
import InputSendMessage from "../Common/Message/InputSendMessage";
import CardContextDynamic from "../Common/CardContextDynamic";
import { fnGetValueByKey } from "../../helpers/functions";
import useGetHeightPage from "../../Hooks/useGetHeightPage";
import ButtonWithDropdown from "../Common/ButtonWithDropdown";
import useGetCsrfToken from "../../Hooks/useGetCsrfToken";

const TableSimpleDynamic = ({
  data,
  fnReplaceParamKeyWithFilteredValue,
  paramsOnFilter,
  triggerOnFilter,
  setTriggerOnFilter,
  inputSearchValue,
  onFilteredDataChange,
  onDataLoaded,
  onRowClick,
  onSortChange,  
  enableDataSharing = false
}) => {
  let dataResult = [];

  if (!!dataResult) {
    try {
      dataResult =
        JSON.parse(fnGetValueByKey(data, "PROCEDURE_RESULTSET")) || [];
    } catch (error) {
      console.warn("Dados pré retornados da procedure não encontrados");
    }
  }

  const csrfToken = useGetCsrfToken();
  const [rowData, setRowData] = React.useState(dataResult);
  const [rowDataClicked, setRowDataClicked] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const { user, isIframePage } = useSelector((state) => ({
    user: state.login.user,
    isIframePage: state.Layout.isIframePage
  }));

  const paddingLeft = 10;
  const columnsList = JSON.parse(
    fnGetValueByKey(data, "TABELA_RESULTADOS_GRID_LISTA_COLUNAS")
  );
  const dataKey = fnGetValueByKey(data, "TABELA_RESULTADOS_GRID_DATA_KEY");

  const enableTotalizers = fnGetValueByKey(
    data,
    "TABELA_RESULTADOS_GRID_TOTALIZADORES",
    false,
    "Childrens"
  );

  const [totalizersList, setTotalizersList] = useState(
    enableTotalizers
    ? JSON.parse(fnGetValueByKey(enableTotalizers, "PROCEDURE_RESULTSET"))
    : []
  );
  

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(1);

  const [openModalVisualization, setOpenModalVisualization] = useState(false);
  const [modalConfig, setModalConfig] = useState([{}]);
  const [modalMessageData, setModalMessageData] = useState(null);
  const [modalMessageLoading, setModalMessageLoading] = useState(false);
  const [urlEmbedModal, setUrlEmbedModal] = useState(null);
  const [iframeHeight, setIframeHeight] = useState(300);

  // const [selectedProduct, setSelectedProduct] = useState(null);

  const [contextMenuCustomPosition, setContextMenuCustomPosition] = useState({ x: 0, y: 0 });
  const [showContextMenuCustom, setShowContextMenuCustom] = useState(false);
  const contextMenuCustomRef = useRef(null);

  const handleGetData = async () => {
    setLoading(true);
    setTriggerOnFilter(false);
    const procName = fnGetValueByKey(data, "PROCEDURE");
    let procParams = fnGetValueByKey(data, "PROCEDURE_PARAM");

    if (paramsOnFilter.length)
      procParams = fnReplaceParamKeyWithFilteredValue(
        paramsOnFilter,
        procParams
      );

    let replaceAllKeysForNull = procParams
      .replaceAll(/<#[^#]+#>/g, null)
      // .replaceAll(/\s/g, "");
    procParams = JSON.parse(replaceAllKeysForNull);
    procParams = Object.assign({}, procParams);
    procParams = Object.values(procParams).map((e) =>
      e === "null" ? null : e
    );

    if (procName && procParams) {
      try {
        const data = await BizinBackend.executeProcedure(
          Object.assign({}, procParams),
          procName,
          csrfToken,
          user?.access_token
        );

        let d = data?.resultset_1 || data;

        if (d) {
          setRowData(d);
          if (data?.resultset_2) setTotalizersList(data?.resultset_2);
          
          if (onDataLoaded) {
            onDataLoaded(d, data?.resultset_2);
          }
        } else {
          console.log("Retorno inesperado: ", data);
          console.log("procName: ", procName);
        }
      } catch (error) {
        console.log("Erro ao buscar dados [Tabela] :", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const paginatorLeft = (props) => {
    return (
      <>
        {enableTotalizers && (
          <div className="d-flex container-left-paginator align-items-center p-0 m-0 gap-4">
            <div
              style={{ width: 150, height: 50 }}
              className="d-flex font-size-12 text-black bg-light-gray-03 p-3 rounded-start-3 justify-content-center align-items-center"
            >
              <span className="text-primary fw-bold">
                {fnGetValueByKey(enableTotalizers, "TITULO")}
              </span>
            </div>
            <div className="col bg-info">
              <div className="d-flex align-items-center gap-3">
                {totalizersList?.map((item, index) => (
                  <div
                    key={index}
                    className="font-size-12 font-w-400 text-dark-gray-primary"
                  >
                    {Object.values(item)[0]}{" "}
                    <span className="text-primary fw-bold">
                      {Object.values(item)[1]}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const paginatorTemplate = {
    layout: "RowsPerPageDropdown PrevPageLink FirstPageLink PageLinks LastPageLink NextPageLink",
    PrevPageLink: (options) => {
      if(options.props.totalPages < 2) return
      return (
        <button
          type="button"
          className={`${options.className} ms-3`}
          onClick={options.onClick}
        >
          <i class="fas fa-chevron-left font-size-12"></i>
        </button>
      )
    },
    NextPageLink: (options) => {
      if(options.props.totalPages < 2) return
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          <i class="fas fa-chevron-right font-size-12"></i>
        </button>
      )
    },
    FirstPageLink: (options) => {
      if(options.props.totalPages <= 5 || options.props.page <= 3 || options.props.totalPages === 6) return
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          1
        </button>
      )
    },
    LastPageLink: (options) => {
      if(options.props.totalPages <= 5 || (options.props.page >= options.props.totalPages - 3) || options.props.totalPages === 6) return
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.props.totalPages}
        </button>
      )
    },
    PageLinks: (options) => {
      if(options.props.totalPages < 2) return
      if (
        (options.view.startPage === options.page &&
          options.view.startPage !== 0) ||
        (options.view.endPage === options.page &&
          options.page + 1 !== options.totalPages)
      ) {
        const className = classNames(
          options.className,
          "rounded-0 m-0 no-hover"
        );
        return <span className={className}> ... </span>;
      }

      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
          <Ripple />
        </button>
      );
    },
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 30, value: 30 },
        { label: "Todos", value: options.totalRecords },
      ];

      return (
        <div
          style={{
            height: 50,
            width:350,
            borderStartEndRadius: 8,
            borderEndEndRadius: 8,
            ...(!enableTotalizers
              ? {
                  borderStartStartRadius:8,
                  borderEndStartRadius: 8,
                }
              : {}),
          }}
          className="p-0 m-0 px-3 d-flex align-items-center gap-2 bg-info justify-content-end align-self-baseline"
        >
          <span className="font-size-14 text-black">Resultados por página</span>
          <Dropdown
            className="mx-2"
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </div>
      );
    },
  };

  function genericTrigger(type, transaction_id, params, config) {
    switch (type) {
      case "Modal":
        if(config && config[0]?.type === "VIEW_MESSAGE"){
          if(config[0]?.procName){
            setModalMessageLoading(!modalMessageLoading);
            BizinBackend.executeProcedure(Object.assign({}, 
              config[0]?.procParams || []), 
              config[0]?.procName, 
              csrfToken,
              user?.access_token)
            .then((response) => {
              if(response?.resultset_1 && response?.resultset_2) {
                let indexFindDivisor = response?.resultset_1.map((i, k) => { if(i.Flag_Visualizacao === "N")  return k }).find(e => e)
                if(indexFindDivisor){
                  response?.resultset_1.splice(indexFindDivisor, 0, {divisor: true})
                }
                
                setModalMessageData(response);
              }
            }).finally(() => {
              setModalMessageLoading(false);
            })
          }
        }else{
          let formatUrl = (transaction_id?.includes('http')) ? transaction_id : (window.location.origin + `/${transaction_id}`);
          setUrlEmbedModal(`${formatUrl}?modal=true&` + params);
        }
        if(config?.length) setModalConfig(config);
        setOpenModalVisualization(true);
        break;
      case "Blank":
        if(transaction_id?.includes('http')) window.open(`${transaction_id}${params ? `?${(params && isIframePage) ? `${params}&${window?.location.search.replace('?', '')}` : params}` : ''}`, '_blank', 'popup');
        else window.open(window.location.origin + `/${transaction_id}${params ? `?${(params && isIframePage) ? `${params}&${window?.location.search.replace('?', '')}` : params}` : ''}`, '_blank');
        break;
      case "Redirect":
        if(transaction_id?.includes('http')) window.open(`${transaction_id}${params ? `?${(params && isIframePage) ? `${params}&${window?.location.search.replace('?', '')}` : params}` : ''}`, '_self');
        else window.open(window.location.origin + `/${transaction_id}${params ? `?${(params && isIframePage) ? `${params}&${window?.location.search.replace('?', '')}` : params}` : ''}`, '_self');
        break;
      case "ActionTarget":
        if(config[0]?.type === "MARKING"){
          // a ser mapeado
        }
        // if(config[0]?.type === "KEBAB"){
        //   setKebabMenuOptions(config[0]?.options || [])
        // }
        break;
      default:
        console.warn(`Tipo ${type} de trigger desconhecido`);
    }
  }

  const handleContextMenu = (event, index) => {
    event.preventDefault();
    setContextMenuCustomPosition({ x: event.pageX, y: event.pageY });
    setShowContextMenuCustom(true);
  };

  const cellBodyTemplate = (rowData, props) => {
    const hasHTMLRegex = /<[^>]+>/;
    let image = rowData[props.field];

    try {
      image = JSON.parse(image);      
    } catch (error) {
      //console.warn(`Coluna {${props.field}} não é um array de objetos`);
    }

    let isArrayAndNotEmpty = Array.isArray(image) && image?.length;

    function getComponent(item, idx, isMultiValues = false) {
      switch (item?.tipo) {
        case "image":
          return (
            <ImageWithTooltip
              id={idx}
              image={item?.valor}
              describe={item?.descricao}
              fn={() => {
                setRowDataClicked(rowData);
                eval(item?.acao)
              }}
            />
          );
        case "icone":
          return (
            <IconWithTooltip
              id={idx}
              icon={`${item?.valor}`}
              describe={item?.descricao}
              fn={() => {
                setRowDataClicked(rowData);
                eval(item?.acao)
              }}
            />
          );
        case "kebab": 
          return (
            <ButtonWithDropdown idx={idx} icone={`${item?.valor}`} options={item?.options} callbackAction={(action) => eval(action)} />
          )
        case "texto":
          return (
            <div><span onClick={() => {
                setRowDataClicked(rowData);
                eval(item?.acao)
              }}>{item?.valor}</span></div>
          );
        default:
          return (
            <i
              className="far fa-user-circle font-size-32 user-photo-label"
              aria-hidden="true"
            />
          );
      }
    }
    
    return (
      <div
        // onContextMenu={handleContextMenu}
        className={`d-flex align-items-center gap-1 justify-content-${props?.column?.props?.alignItem || 'start'} ${rowData?.Flag_Visualizacao === 'N' ? 'no-visited' : ''}`}>
        {props?.column?.props?.hasImage ? (
          <>
            {isArrayAndNotEmpty
              ? image?.map((item, idx) =>
                  getComponent(item, `${props.rowIndex}-${idx}-${props?.column?.props?.field}`, (image?.length > 1))
                )
              : getComponent(image, `${props.rowIndex}-${props?.column?.props?.field}`)}
          </>
        ) : (
          <>
            {hasHTMLRegex.test(image) ? (
              <div dangerouslySetInnerHTML={{ __html: image }}></div>
            ) : (
              <div>
                <span>{rowData[props.field]}</span>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const onGlobalFilterChange = (value) => {
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
  };

  // const customSort = (field) => {
  //   setSortField(field);
  //   setSortOrder(sortOrder === 1 ? -1 : 1);
  // };

const sortedData = React.useMemo(() => {
  const sorted = [...rowData]?.sort((a, b) => {
    if (sortField) {
      let compareValueA = a[sortField];
      let compareValueB = b[sortField];

      try {
        let extractValueA = JSON.parse(a[sortField]);
        let extractValueB = JSON.parse(b[sortField]);

        Object.values(extractValueA).find(i => {
          if (i.tipo === 'texto')
            console.log(i.valor)
            compareValueA = i.valor
        })

        Object.values(extractValueB).find(i => {
          if (i.tipo === 'texto')
            console.log(i.valor)
            compareValueB = i.valor
        })

      } catch (error) {
        console.warn("SORT: item da coluna não é um array de objeto ")
      }

      const isDateBR = (v) =>
        typeof v === 'string' &&
        /^\d{2}\/\d{2}\/\d{4}( \d{2}:\d{2}:\d{2})?$/.test(v.trim());

      const parseDateBR = (v) => {
        const [date, time = '00:00:00'] = v.split(' ');
        const [d, m, y] = date.split('/');
        const [h, min, s] = time.split(':');

        return new Date(y, m - 1, d, h, min, s).getTime();
      };

      const isMoney = (v) =>
        typeof v === 'string' &&
        /^(R\$\s?)?-?\d{1,3}(\.\d{3})*(,\d{2})$/.test(v.trim());

      const parseBRL = (v) =>
        parseFloat(
          v.replace(/[^\d,-]/g, '').replace(/\./g, '').replace(',', '.')
        );

      const isNumber = (v) =>
        typeof v === 'number' || (!isNaN(v) && v !== null && v !== '');

      const naturalCompare = (a, b) => {
        const tokenize = (str) =>
          String(str)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .match(/(\d+|\D+)/g);

        const A = tokenize(a);
        const B = tokenize(b);

        const len = Math.max(A?.length, B?.length);

        for (let i = 0; i < len; i++) {
          const partA = A[i];
          const partB = B[i];

          if (partA === undefined) return -1;
          if (partB === undefined) return 1;

          const numA = Number(partA);
          const numB = Number(partB);

          const isNumA = !isNaN(numA);
          const isNumB = !isNaN(numB);

          if (isNumA && isNumB) {
            if (numA !== numB) return numA - numB;
          } else {
            const result = partA.localeCompare(partB, 'pt-BR', {
              sensitivity: 'base'
            });

            if (result !== 0) return result;
          }
        }

        return 0;
      };

      if (compareValueA == null) compareValueA = '';
      if (compareValueB == null) compareValueB = '';

      // 🗓️ DATA
      if (isDateBR(compareValueA) && isDateBR(compareValueB)) {
        return (parseDateBR(compareValueA) - parseDateBR(compareValueB)) * sortOrder;
      }

      // 💰 MOEDA
      if (isMoney(compareValueA) && isMoney(compareValueB)) {
        return (parseBRL(compareValueA) - parseBRL(compareValueB)) * sortOrder;
      }

      // 🔢 NÚMERO
      if (isNumber(compareValueA) && isNumber(compareValueB)) {
        return (Number(compareValueA) - Number(compareValueB)) * sortOrder;
      }

      // 📝 TEXTO (natural)
      return naturalCompare(compareValueA, compareValueB) * sortOrder;
    }

    return 0;
  });

  return sorted;
}, [rowData, sortField, sortOrder]);

  const filteredData = React.useMemo(() => {
    let filtered = [...sortedData];
    
    if (filters.global.value) {
      filtered = filtered.filter(row => {
        return Object.values(row).some(value => {
          if (value === null || value === undefined) return false;
          return String(value).toLowerCase().includes(filters.global.value.toLowerCase());
        });
      });
    }
    
    return filtered;
  }, [sortedData, filters.global.value]);
  

  const renderHeader = (col) => {
    const sortable = col?.sort && col?.sort === "True" ? true : false
    return (
      <div className="flex align-items-center justify-content-center">
        {col?.header}
        {sortable && (
          <>
            {sortField === col?.field && (
              <i
                className={`fas fa-sort-${
                  sortOrder === 1 ? "down mb-1" : "up mt-1"
                } ps-2 text-light-blue-11`}
              ></i>
            )}
            {sortField !== col?.field && <i class="ps-2 fas fa-sort"></i>}
          </>
        )}
      </div>
    );
  };

  useEffect(() => {
    const messageListener = (event) => {
      if(event.data.iframeHeight) {
        setIframeHeight(event.data.iframeHeight);
      }
    };
    window.addEventListener("message", messageListener);
    return () => {
      window.removeEventListener("message", messageListener);
    };
  }, []);

  useGetHeightPage()

  useEffect(() => {
    if (triggerOnFilter) handleGetData();
  }, [triggerOnFilter]);

  useEffect(() => {
    if (rowData.length == 0) handleGetData();
  }, []);

  useEffect(() => {
    onGlobalFilterChange(inputSearchValue);
  }, [inputSearchValue]);
  
  useEffect(() => {    
    if (enableDataSharing && onFilteredDataChange) {
      onFilteredDataChange(filteredData);
    }
  }, [filteredData, enableDataSharing, onFilteredDataChange]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (contextMenuCustomRef.current && contextMenuCustomRef.current instanceof HTMLElement) {
        if (!contextMenuCustomRef.current.contains(event.target)) {
          setShowContextMenuCustom(false);
        }
      } else {
        setShowContextMenuCustom(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [selectedProducts, setSelectedProducts] = useState(null);
  return (
    <>
      <PrimeDataTable.DataTable
        tableClassName="table mb-0 table-light font-size-14 table-sm"
        value={sortedData}
        paginatorTemplate={paginatorTemplate}
        sortMode="single"
        groupRowsBy={dataKey}
        rowGroupMode="rowspan"
        // expandedRows={expandedRows}
        // onRowToggle={(e) => setExpandedRows(e.data)}
        dataKey={dataKey}
        loading={loading}
        loadingIcon={<Spinner className="text-primary" size="sm" />}
        reorderableColumns={
          fnGetValueByKey(data, "TABELA_RESULTADOS_GRID_ORDENACAO_COLUNAS") !==
          "False"
        }
        paginatorClassName="paginator-table-custom pt-3 pb-3 px-0"
        paginatorLeft={paginatorLeft}
        // footerColumnGroup={resultset2?.isFooter == "S" ? footerGroup : <></>}
        pageLinkSize={6}
        // totalRecords={total}
        paginator
        rows={Number(
          fnGetValueByKey(data, "TABELA_RESULTADOS_GRID_LINHAS_PAG")
        )}
        //input filter
        emptyMessage={"Nenhum registro encontrado."}
        filters={filters}
        onRowClick={onRowClick}

        selection={selectedProducts}
        selectionMode="single" //checkbox
        onSelectionChange={(e) => {
           setSelectedProducts(e.value)
          if(e.value?.Linha_Acao?.includes('genericTrigger')) eval(e.value?.Linha_Acao)
        }}
      >
        {/* <Column selectionMode="multiple" headerStyle={{padding: 5, background: "#D9D9D9"}}></Column> */}
        {columnsList.map((col, i) => (
          <Column
            style={{ paddingLeft: i === 0 ? paddingLeft : 10 }}
            key={col.field}
            sortable={col?.sort && col?.sort === "True" ? true : false}
            sortFunction={( e) => {
              setSortField(e.field);
              setSortOrder(e.order);
              
              if (onSortChange) {
                onSortChange(e.field, e.order);
              }
              
              return e.data
            }}
            headerStyle={{
              background: "#D9D9D9",
              width: col?.width ? col.width : "auto",
            }}
            bodyStyle={{
              padding: `0 10px 0 ${paddingLeft}`,
            }}
            className={col?.styles ? col?.styles : ""}
            hasImage={col?.hasImage === "True" ? true : false}
            alignItem={col?.align || 'right'}
            field={col.field}
            body={cellBodyTemplate}
            header={renderHeader(col)}
          />
        ))}
      </PrimeDataTable.DataTable>

      {/* <button
        className="btn btn-primary btn-sm"
        onClick={() => {
          window.open(`/BI_WS0020?modal=true`, '_self', 'noopener,noreferrer');
        }}
      >
        Teste redirect
      </button> */}

      {/* Context menu custom */}
      <UncontrolledDropdown
        isOpen={showContextMenuCustom}
        ref={contextMenuCustomRef}
        toggle={() => setShowContextMenuCustom(!showContextMenuCustom)}
        className="absolute context-menu-custom"
        style={{
          top: contextMenuCustomPosition.y - 890,
          left: contextMenuCustomPosition.x - 80,
        }}
      >
        <DropdownMenu className="dropdown-kebab-custom-table dropdown-menu-end">
          <DropdownItem className="d-flex align-items-center"><a href="/" className="p-0 m-0"><i className="ri-pencil-fill align-bottom me-2 text-color-azul8" /> Action test </a></DropdownItem>
          <DropdownItem className="d-flex align-items-center"><a href="/" className="p-0 m-0"><i className="ri-pencil-fill align-bottom me-2 text-color-azul8" /> Action test </a></DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>

      {/* Modals */}
      <Modal
        className={`modal-dinamic-table-simple ${modalConfig[0]?.type ? `type-${modalConfig[0].type}` : ''}`}
        isOpen={openModalVisualization}
        style={(modalConfig.length ? { width: modalConfig[0].width } : {})}
        toggle={() => {
          setOpenModalVisualization(!openModalVisualization);
        }}
      >
        {/* style={(modalConfig.length ? { height: modalConfig[0].height } : {})} */}
        <div > 
           <div className="modal-header d-flex align-items-center justify-content-between">
            <h5
              className="modal-title mt-0 font-size-24 font-w-600 text-color-azul1"
              id="myModalLabel"
            >
              {modalConfig[0]?.titleModal || 'Não mapeado'}
            </h5>            
            <button
              type="button"
              onClick={() => {
                setOpenModalVisualization(!openModalVisualization);
                setModalMessageData({});
              }}
              className="btn border-0 p-0"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i className="fas fa-times font-size-24 text-gray-secundary"></i>
            </button>
          </div>
          {modalConfig[0]?.type === "VIEW_TIMELINE" && (
            <div className="modal-body">
              {urlEmbedModal && (
                <iframe
                  src={urlEmbedModal}
                  style={{ width: '100%', height: '100%', border: 'none' }}
                  title="Histórico do Documento"
                  allowFullScreen="true"
                />
              )}
            </div>
          )}
          {modalConfig[0]?.type === "VIEW_MESSAGE" && (
            <div className="modal-body" >
              <div className="container-flow pb-3">
                <div className="d-flex gap-3 align-items-center px-1">
                  <div className={`${fnGetValueByKey(modalMessageData?.resultset_3, "PROCEDURE_RESULTSET") ? "col-auto" : "col"}`}>
                    <CardFlowDynamic flowData={modalMessageData?.resultset_2} />
                  </div>
                  {modalMessageData?.resultset_3 && fnGetValueByKey(modalMessageData?.resultset_3, "PROCEDURE_RESULTSET") && (
                    <div className="col">
                      <CardContextDynamic contextBlock={modalMessageData?.resultset_3} isRenderModal={true} />
                    </div>
                  )}
                  </div>
              </div>
              <div className="list-messages px-1">
                {modalMessageLoading
                  ? <div className="d-flex justify-content-center align-items-center h-100"><Spinner className="text-primary" size="sm" /></div>
                  :  <>
                  {modalMessageData?.resultset_1?.reverse()?.map((item, index) => {
                    
                    let isMessageToUser = user?.resultset_2[0]?.ID_Usuario === item.ID_Usuario

                    return(
                      <>
                      {item?.divisor ? (
                        <div className="divider-no-view py-1">
                          <hr/>
                          <div className="text-center d-flex align-items-center"><p className="label">Última lida</p></div>
                          <hr/>
                        </div>
                      ): (
                        <div className={`${isMessageToUser ? "message-content-box-right" : ""}
                        ${isMessageToUser && modalMessageData?.resultset_1[index - 1]?.ID_Usuario !== item.ID_Usuario ? "mb-2" : ""}
                        ${isMessageToUser && modalMessageData?.resultset_1[index + 1]?.ID_Usuario !== item.ID_Usuario ? "mt-2" : ""}
                        `}>
                          <MessageContentBox data={item} key={index} id={index} isRight={isMessageToUser}  />
                        </div>
                      )}
                      </>
                  )})}
                  </>                  
                }                
              </div>
              <div className="px-1 pt-3">
                <InputSendMessage data={rowDataClicked} onSuccess={(message, files = []) => {
                  let itemData = modalMessageData?.resultset_1?.find(item => item.ID_Usuario === user?.resultset_2[0]?.ID_Usuario)
                  
                  const newMessage = {
                    "ID_Arquivo": itemData?.ID_Arquivo,
                    "Data_Mensagem": new Date().toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
                    "Conteudo_Mensagem": message,
                    "Nome_Completo": user?.resultset_2[0]?.Nome_Completo,
                    "Foto_Usuario": user?.resultset_2[0]?.Foto_Usuario,
                    "ID_Usuario": user?.resultset_2[0]?.ID_Usuario,
                    "Numero_Documento": itemData?.Numero_Documento,
                    "Anexos": JSON.stringify(files)
                  }
                  const newModalMessageData = [...modalMessageData.resultset_1]
                  newModalMessageData.push(newMessage)
                  setModalMessageData(state => ({...state, resultset_1: newModalMessageData}))
                }} />
              </div>
            </div>
          )}

          {!modalConfig[0]?.type && (            
            <div className="modal-body" style={(modalConfig.length ? { height: `${iframeHeight+60}px` } : {})}>
              {urlEmbedModal && (
                <iframe
                  id="embed-view-in-modal"
                  width="100%"
                  height={`${iframeHeight+20}px`}
                  src={urlEmbedModal}
                  frameborder="0"
                  allowFullScreen="true"
                >
                </iframe>
              )}
            </div>
          )}
            
        </div>
        
      </Modal>
    </>
  );
};

export default TableSimpleDynamic;
